import { T } from 'lib/tolgee'

import './styles.scss'

export default function ZaiDataStamp() {
  return (
    <div className="ZaiDataStamp">
      <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.45781 0.489685L10.2145 3.03914L15 2.23354L12.8911 11.5103L7.45686 10.7126L7.44508 10.7144L2.3852 11.5043L0.0297084 2.31331L0 2.19689L4.71477 3.00437L7.45781 0.489685ZM4.34832 8.57776L7.44497 8.09448L10.908 8.6028L11.6058 5.43047L9.36765 5.80752L7.4544 4.03816L7.45016 4.03445L5.552 5.77414L3.54163 5.43L4.34832 8.57776Z"
          fill="#6324C6"
        />
      </svg>
      <T keyName={`ZaiCardBox-zaiFooter`}>Baseado em dados proprietários da Winnin Intelligence</T>
    </div>
  )
}
